export default "__VITE_ASSET__CL$IgdDb__"